module.exports = __webpack_public_path__ + "static/media/user-placeholder.c9d82b18.jpg";